const riot = require('riot');

riot.tag2('page-index', '<div class="s-full bg-cream"> <div class="sticky t0 z100" data-is="module-header" title="{t(&quot;index.title&quot;)}"></div> <div class="bg-cream"> <div class="container h-full px20 py20 anim-appear" if="{children}"><a class="block rounded-8 border border-dark-012 overflow-hidden cursor-pointer mb20" href="{t(\'index.privacy_policy_link\')}" target="_blank"> <div class="bg-white border-dark-012 f fm flex-between px16 py10"> <div class="text-attention fw6">{t(⁗index.privacy_policy⁗)}</div><i class="icon-arrow_right text-dark-026 fs20"></i> </div></a> <div class="rounded-8 border border-dark-012 overflow-hidden cursor-pointer mb20"> <div class="bg-white border-dark-012 f fm flex-between px16 py1 {&quot;border-bottom&quot;: isShow}" onclick="{toggleShow}"> <div class="f fm"><i class="icon-face fs32 mr16 text-custom-{currentChild.theme_color}"></i> <div class="fs16 fw6">{currentChild.name}{t(⁗index.setting⁗)}</div> </div><i class="icon-arrow_right text-dark-026 fs20 rotate-90 {&quot;hide&quot;: isShow}"></i> </div> <div class="transition max-h0 overflow-hidden" ref="other-children"> <div> <div class="bg-white border-bottom-not-last border-dark-012 f fm px16 py1" each="{child in getOtherChildren()}" onclick="{changeChild}"><i class="icon-face fs32 mr16 text-custom-{child.theme_color}"></i> <div class="fs16 fw6">{child.name}{t(⁗index.setting⁗)}</div> </div> <div class="bg-white border-bottom-not-last border-dark-012 f fm px16 py1" onclick="{addChild}"><i class="icon-face fs32 mr16 text-dark-026"></i> <div class="fs16 fw6">{t(⁗index.add_child⁗)}</div> </div> </div> </div> </div> <div class="rounded-8 border border-dark-012 overflow-hidden"><a class="border-bottom-not-last border-dark-012 f fm flex-between px16 pt8 pb7 bg-{item.bg_danger ? &quot;attention-light&quot;: &quot;white&quot;}" each="{item in editLists}" href="{getLink(item)}"> <div class="f fm"><i class="fs32 mr16 icon-{item.icon} text-{item.icon_color}"></i> <div class="fw6">{t(⁗index.⁗ + item.label)}</div> </div><i class="icon-arrow_right text-dark-026 fs20"></i></a></div> </div> </div> </div>', 'page-index,[data-is="page-index"]{display:block}', '', function(opts) {
    this.editLists = [
      {
        icon: 'list',
        label: 'works',
        link: '/works',
        icon_color: 'primary-light',
      },
      {
        icon: 'coin',
        label: 'amount_account',
        link: '/bank/account',
        icon_color: 'primary-light',
      },
      {
        icon: 'coin',
        label: 'amount_loan',
        link: '/bank/loan',
        icon_color: 'primary-light',
      },
      {
        icon: 'face_parts',
        label: 'user',
        link: '/user',
        icon_color: 'primary-light',
      },
    ];

    this.preload = async ({req, res}) => {
      var ref = db.collection('groups');
      var ss = await ref.get({source: "cache"});

      var items = ss.docs.map(doc => {
        return {
          id: doc.id,
          ref: doc.ref,
          data: doc.data(),
        }
      });

      if (spat.isBrowser) {

        var token = req.query.token;
        if (token) {
          localStorage.setItem('piguchi_token', token);
          app.api.setToken(token);

          history.replaceState(null, null, location.pathname);
        }
      }

      return {
        items,
      };
    };

    this.head = () => {
      return {
        title: t("meta.title"),
        description: t("meta.description"),
      };
    };

    this.on('show', async (e) => {

      var res = await app.api.request({
        method: 'get',
        url: `/web/children`,
      });

      this.children = res.data.children;

      if (localStorage.getItem('selected-id')) {

        var id = localStorage.getItem('selected-id');
        this.currentChild = this.children.find(child => child.id === id);
      }

      if (!this.currentChild) {

        this.currentChild = this.children[0];
      }

      this.checkRequestedLoan();
      this.update();
    });

    this.checkRequestedLoan = async () => {

      var res = await app.api.request({
        method: 'get',
        url: `/web/children/${this.currentChild.id}/bank/loan/requests/review`,
      });

      this.isRequestedLoan = !!res.data.loan_request

      if (this.isRequestedLoan) {
        this.editLists.unshift(
          {
            icon: 'alert',
            label: 'loan_request',
            link: '/loan',
            icon_color: 'attention',
            bg_danger: true,
        });
        this.update();
      }
    };

    this.toggleShow = () => {
      this.isShow = !this.isShow;
      this.update();

      if (this.isShow) {
        this.refs['other-children'].style.maxHeight = getComputedStyle(this.refs['other-children'].children[0]).height;
      }
      else {
        this.refs['other-children'].style.maxHeight = 0;
      }
    };

    this.changeChild = async (e) => {
      this.currentChild = e.item.child;

      localStorage.setItem("selected-id", this.currentChild.id);

      this.toggleShow();

      var index = this.editLists.findIndex(item => item.label === 'loan_request');
      if (index !== -1) {
        this.editLists.splice(index, 1);
      }

      await this.checkRequestedLoan();
      this.update();
    };

    this.getOtherChildren = () => {
      return this.children.filter(child => child.id !== this.currentChild.id);
    };

    this.getLink = (item) => {
      return "children/" + this.currentChild.id + item.link;
    };

    this.addChild = () => {
      spat.router.push('/children/new/user');
    };
});